var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 14.8855C36.6663 13.8758 36.6663 13.371 36.4667 13.1372C36.2934 12.9344 36.0336 12.8267 35.7676 12.8477C35.4611 12.8718 35.1042 13.2288 34.3902 13.9427L28.333 19.9999L34.3902 26.0571C35.1042 26.7711 35.4611 27.1281 35.7676 27.1522C36.0336 27.1731 36.2934 27.0655 36.4667 26.8626C36.6663 26.6288 36.6663 26.124 36.6663 25.1143V14.8855Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 16.3333C3.33301 13.533 3.33301 12.1329 3.87798 11.0633C4.35734 10.1225 5.12225 9.35759 6.06306 8.87822C7.13261 8.33325 8.53275 8.33325 11.333 8.33325H20.333C23.1333 8.33325 24.5334 8.33325 25.603 8.87822C26.5438 9.35759 27.3087 10.1225 27.788 11.0633C28.333 12.1329 28.333 13.533 28.333 16.3333V23.6666C28.333 26.4668 28.333 27.867 27.788 28.9365C27.3087 29.8773 26.5438 30.6423 25.603 31.1216C24.5334 31.6666 23.1333 31.6666 20.333 31.6666H11.333C8.53275 31.6666 7.13261 31.6666 6.06306 31.1216C5.12225 30.6423 4.35734 29.8773 3.87798 28.9365C3.33301 27.867 3.33301 26.4668 3.33301 23.6666V16.3333Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryVideo);
export default __webpack_public_path__ + "react/media/category-video.6f4771000abcd6a653da847e4ab9f7d7.svg";
export { ForwardRef as ReactComponent };